export default __webpack_public_path__ + "static/media/dialogue-right.16f998d5.png";